mutation CancelDripSequence($input: DripSequenceCancelInput!) {
    dripSequenceCancel(input: $input) {
        dripSequence {
            id
        }
    }
}
